import { useAppSelector } from "@/store";
import {
  Box,
  Flex,
  FlexProps,
  Image,
  ImageProps,
  Text,
} from "@chakra-ui/react";
import React from "react";

interface ProfileSectionProps {
  profileImageWrapperProps?: FlexProps;
  profileImageProps?: ImageProps;
  profileInfoWrapperProps?: FlexProps;
}

const ProfileSection = ({
  profileImageWrapperProps,
  profileImageProps,
  profileInfoWrapperProps,
}: ProfileSectionProps) => {
  const { user } = useAppSelector((state) => state.user);

  // const handleUploadImage = (file: File) => {
  //   const formData = new FormData();
  //   formData.append("image", file);
  //   return updateUser(formData)
  //     .unwrap()
  //     .then(() => {
  //       success("Profile image updated successfully");
  //       const fileReader = new FileReader();
  //       fileReader.readAsDataURL(file);
  //       fileReader.onload = () => {
  //         dispatch(
  //           updateUserProfileAction({
  //             image: (fileReader.result as string) || null,
  //           }),
  //         );
  //       };
  //     })
  //     .catch((err) => {
  //       catchErrorHandler(err, errorToast);
  //     });
  // };
  return (
    <Box p={"20px"}>
      <Flex
        justifyContent={"center"}
        alignItems={"center"}
        gap={2}
        {...profileImageWrapperProps}
      >
        <Image
          borderRadius={"50%"}
          src={user.image || ""}
          alt={user.username || "Profile Image"}
          border={"2px solid #f36f21"}
          h={"160px"}
          w={"160px"}
          fallbackSrc="https://dev-minio-api.pvsage.com/amphitheater/None/static/sob/sob_9D6WDfDCGqpTU8tibSpcV3.png"
          {...profileImageProps}
        />
        {/* <label>
          <input
            type="file"
            accept="image/*"
            onChange={(e) => {
              if (e.target.files) handleUploadImage(e.target.files[0]);
            }}
            style={{ width: 0, height: 0 }}
          />
          <Text color={"#575757"}>Change Image</Text>
        </label> */}
      </Flex>
      <Flex
        justifyContent={"center"}
        direction={"column"}
        alignItems={"center"}
        {...profileInfoWrapperProps}
      >
        <Text fontSize={"18px"} margin={"15px 0"} color={"#000000"}>
          {user.email}
        </Text>
        <Text fontSize={"18px"} color={"#575757"}>
          Member Id: {user.username}
        </Text>
        <Text fontSize={"18px"} color={"#575757"}>
          RewardPoints: {user.member?.available_points}
        </Text>
      </Flex>
    </Box>
  );
};

export default ProfileSection;
